import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-80">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-81">
        <img src="https://cdn.magicpatterns.com/uploads/gsce6zR8NoWX5T3aaBwmRP/Screenshot_2026-01-19_at_11.03.32_AM.png" alt="Desert Hills Estate at Sunset" className="w-full h-full object-cover" data-id="element-82" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" data-id="element-83" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl mx-auto" data-id="element-85">
          <span className="inline-block py-1 px-3 mb-6 border border-white/30 rounded-full text-white/90 text-sm tracking-widest uppercase backdrop-blur-sm" data-id="element-86">
            Desert Hills, Arizona
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-87">
            Freedom, Privacy, and <br data-id="element-88" />
            <span className="italic font-light" data-id="element-89">Room to Breathe</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto font-light" data-id="element-90">
            A rare foothills estate designed for those who need space. No HOA,
            over an acre of land, and a dedicated workshop for your passions.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-91">
            <Button variant="primary" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-92">
              Schedule a Private Tour
            </Button>
            <Button variant="white" size="lg" onClick={() => document.getElementById('overview')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-93">
              Explore the Property
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 text-white/70" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-94">
        <ArrowDown size={32} strokeWidth={1.5} data-id="element-95" />
      </motion.div>
    </section>;
}